import React from 'react';

import { Breakpoint, Container, styled } from '@mui/material';

interface CustomContainerProps {
  readonly center?: boolean;
  readonly centerText?: boolean;
}

const createPropFilter = (props: ReadonlyArray<PropertyKey>) => (prop: PropertyKey) => {
  return !props.includes(prop);
};

const StyleContainer = styled(Container, {
  shouldForwardProp: createPropFilter(["center", "centerText"]),
})<CustomContainerProps>`
  justify-content: ${(props) => (props.center ? "center" : "")};
  text-align: ${(props) => (props.centerText ? "center" : "")};
`;

export const FormContentContainer = ({ maxWidth = "xs", ...rest }: Props) => (
  <StyleContainer maxWidth={maxWidth} {...rest} />
);

export const PageContentContainer = ({ maxWidth = "md", ...rest }: Props) => (
  <StyleContainer maxWidth={maxWidth} {...rest} />
);

interface Props extends CustomContainerProps {
  readonly children: React.ReactNode;
  readonly maxWidth?: Breakpoint;
}
